import React from "react";
import EventCarouse from "../Events/EventCarouse";

const EventSection = () => {
  return (
    <div className="container">
      <div className="row mb--10 mt--20">
        <div className="col-lg-12">
          <div className="section-title text-center">
            <span className="subtitle bg-secondary-opacity">
              STIMULATED TO TAKE PART IN ?
            </span>
            <h2 className="title">Upcoming Events</h2>
          </div>
        </div>
      </div>
      <div className="row mt--80">
        <EventCarouse />
      </div>
    </div>
  );
};

export default EventSection;
